// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IGetSpamChatsDesktopRequest,
  TGetSpamChatsDesktopModel,
  IMappers,
  TGetSpamChatsDesktopResponse,
  IGetSpamChatsDesktopResponse,
  IGetSpamChatsDesktopResponseError,
} from './types';

export const defaultConfig: TGetSpamChatsDesktopModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'GET',
  microserviceName: 'chats',
  pathApi: '/v1/get-spam-chats-desktop/',
} as TGetSpamChatsDesktopModel;

export function createGetSpamChatsDesktopModel(parameters: IGetSpamChatsDesktopRequest): TGetSpamChatsDesktopModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetSpamChatsDesktopOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetSpamChatsDesktopRequest;
}

export async function fetchGetSpamChatsDesktop<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetSpamChatsDesktopOptions<TResponse200, TResponse400>): Promise<
  TGetSpamChatsDesktopResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(createGetSpamChatsDesktopModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetSpamChatsDesktopResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IGetSpamChatsDesktopResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TGetSpamChatsDesktopResponse;
}
